import React, { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

const FireworksReward = ({ onComplete, points }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Trigger fireworks
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });

    // Auto dismiss after 3 seconds
    const timeout = setTimeout(() => {
      onComplete && onComplete();
    }, 3000);

    return () => clearTimeout(timeout);
  }, [onComplete]);

  return (
    <div ref={containerRef} style={styles.overlay}>
      <div style={styles.feedback}>{`+${points} Points!`}</div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  },
  feedback: {
    fontSize: '3rem',
    color: '#fff',
    fontWeight: 'bold',
    backgroundColor: '#a855f7',
    padding: '1rem 2rem',
    borderRadius: '10px',
    boxShadow: '0 0 20px rgba(0,0,0,0.4)'
  }
};

export default FireworksReward;
